import BackButton from '@sophocles/components/BackButton/BackButton';

export default BackButton;
